export const LOCATION_DATA = {
	coords: {
		latitude: 45.1,
		longitude: -78.7
	}
};
